export const NAVBAR_MENU_DROPDOWN_ITEM_DEFAULTS_V2 = {
  padding: '8px',
  width: '100%',
  overflow: 'hidden',
  borderRadius: '8px',
  titleFontSize: '14px',
  titleFontWeight: '500',
  titleLetterSpacing: '0px',
  descriptionFontSize: '13px',
  descriptionFontWeight: '400',
  descriptionLetterSpacing: '0px',
  background: '#ffffff',
  hoverBackgroundColor: '#F2F4F7',
  textColor: '#000000',
  fontFamily: 'Inter',
  descriptionTextColor: '#667085',
  iconColor: '#98A2B3',
  iconBackgroundColor: '#F2F4F7',
  borderColor: 'transparent',
  borderWidth: '0px',
  borderStyle: 'solid',
};
